<bzg-modal-header>
  {{data.entry.Name | uppercase}}
</bzg-modal-header>
<bzg-modal-content>
  <bzg-message class="bz-environment-advanced-left__message--info bz-space--stack-m" [showCloseBtn]="true" [status]="'info'" *ngIf="hasMoreResults && this.continuationToken && contentEntries?.length && !showSelection">
    <span class="bz-space--inline-m"> {{'TRACE.MESSAGE_INFO_TRACE_DETAIL' | translate}} </span>
  </bzg-message>
  <bzg-message *ngIf="!data.entry.Category" class="bz-environment-advanced-left__message--info bz-space--stack-m" [showCloseBtn]="true" [status]="'info'">
    <span class="bz-space--inline-m"> {{'TRACE.MESSAGE_INFO_TRACE_OLD' | translate}} </span>
  </bzg-message>
  <div class="bmc-modal-viewer-detail__show-recent">
    <div *ngIf="data.entry.Category">{{'TRACE.MESSAGE_TRACE_DETAIL' | translate}}</div>
  </div>
  <div *ngIf="data.entry.Category" class="bmc-modal-viewer-detail__date-time bz-space--stack-m">
    <bzg-date-picker *ngIf="!isChangingTime" class="bz-space--inline-xl" [maxDate]="maxDate" [(ngModel)]="onDate" (ngModelChange)="changeDate()">
      {{'TRACE.TRACE_DETAIL_DATE' | translate}}
    </bzg-date-picker>
    <bzg-time-picker *ngIf="!isChangingTime" [(ngModel)]="onTime" (change)="onTimeChange()">
      {{'JOBS.TIME' | translate}}
    </bzg-time-picker>
  </div>

  <div *ngIf="!showLoading">
    <bzg-radio-group  *ngIf="traceFilter.category == 'Rules'" [(ngModel)]="showSelection" (change)="changeSelection()"
      isHorizontal="true" class="bmc-modal-viewer-detail__recent-radio">
      <bzg-radio-button [value]="false" class="bmc-modal-viewer-detail__recent-radio-option">{{'TRACE.SHOW_NEWEST_FIRST' | translate}}</bzg-radio-button>
      <bzg-radio-button [value]="true" class="bmc-modal-viewer-detail__recent-radio-option">{{'TRACE.SHOW_OLDEST_FIRST' | translate}}</bzg-radio-button>
    </bzg-radio-group>
  </div>


  <div class="bmc-modal-viewer-detail__container-data">
    <bzg-table [showSelectionColumn]="isTypeFileSelectable()" (selectItems)="setSelectedEntries($event)"
    *ngIf="contentEntries && contentEntries.length && isTypeFileSelectable()" [(model)]="contentEntries" [showPaginator]="false">
      <ng-template bzgTableColumnDetail bzgTableColumn [allowOrder]="false" title="{{'TRACE.RESULT_FILENAME' | translate}}" let-dataItem="dataItem" visibleCondition="false">
        <div class="bmc-modal-viewer-detail__message">
          <b>
            {{ content.Timestamp | showDateFormat:1 }}
            <svg class="bz-icon-svg--16 bz-icn">
              <use xlink:href="#arrow-up-special" />
            </svg>
          </b>
          <div>{{dataItem.MessageLog}}</div>
        </div>
      </ng-template>
    </bzg-table>
    <ul *ngIf="contentEntries && contentEntries.length && !isTypeFileSelectable() && !contentEntriesCustom.length && !showLoading && !(contentEntriesCustom.length == 10000 && hasMoreResults)" class="bmc-modal-viewer-detail__container">
      <li *ngFor="let content of contentEntries">
        <div class="bmc-modal-viewer-detail__message"> <span><b class="bmc-modal-viewer-detail__padding-right">{{ content.Timestamp | showDateFormat:5 }}</b>{{content.MessageLog}}</span></div>
      </li>
    </ul>
    <ul *ngIf="contentEntries && contentEntries.length && !isTypeFileSelectable() && contentEntriesCustom.length && !showLoading && !(contentEntriesCustom.length == 10000 && hasMoreResults)" class="bmc-modal-viewer-detail__container">
      <li *ngFor="let content of contentEntriesCustom">
        <div class="bmc-modal-viewer-detail__message"> <span><b class="bmc-modal-viewer-detail__padding-right">{{ content.Timestamp | showDateFormat:5 }}</b>{{content.MessageLog}}</span></div>
      </li>
    </ul>

    <div *ngIf="contentEntriesCustom && contentEntriesCustom.length == 10000 && !showLoading && hasMoreResults && showSelection" class="bmc-modal-viewer-detail__latest-info">
      {{'TRACE.SHOW_LATEST_DOWNLOAD' | translate}}
    </div>

    <div class="bmc-modal-viewer-detail__loading">
      <bzg-loading class="bmc-trace__loading" [size]="'m'" *ngIf="showLoading">{{ loadingMessage }}</bzg-loading>
    </div>
  </div>
  <a *ngIf="hasMoreResults && this.continuationToken && contentEntries?.length && !showSelection && !showLoading" (click)="loadResults('later')" class="bmc-modal-viewer-detail__load-more-option">
    {{'TRACE.LOAD_LATER_RESULTS' | translate}}
  </a>
</bzg-modal-content>
<bzg-modal-footer class="bmc-modal-viewer-detail__footer">
  <bzg-button-secondary class="bz-space--inline-m" (click)="close()">{{ 'GLOBAL.CLOSE' | translate }}</bzg-button-secondary>

  <bzg-button-primary class="bz-space--inline-m"  *ngIf="!showLoading && !isChangingTime && data.entry.Category && !showSelection" (click)="downloadFile()"
  [disabled]="isDisabled()">
    {{'TRACE.DOWNLOAD_SCREEN' | translate}}
  </bzg-button-primary>

  <bzg-button-primary class="bz-space--inline-m" *ngIf="!showLoading && !isChangingTime && data.entry.Category" (click)="downloadAll()"
  [disabled]="isDisabled()">
    {{'TRACE.DOWNLOAD_ALL' | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
